import spain from "../assets/images/flags/spain.jpg";
import usflag from "../assets/images/flags/us.jpg";

const languages: Object = {
  sp: {
    label: "Spanish",
    flag: spain,
  },
  en: {
    label: "English",
    flag: usflag,
  },
};

export default languages;
